import { render, staticRenderFns } from "./ActionTable.vue?vue&type=template&id=6201f0af"
import script from "./ActionTable.vue?vue&type=script&lang=js"
export * from "./ActionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports